import styled, { css } from 'styled-components'
import { Variables } from '../styles/Variables'
import media from 'css-in-js-media'

const H1 = styled.h1`
    font-family: ${Variables.font.title};
    font-style: normal;
    font-weight: 400;
    font-size: 36px;
    line-height: 117%;
    letter-spacing: 0.0025em;
    margin: 0;
    color: ${Variables.color.cocoa};

    ${media('>desktop')} {
        font-size: 60px;
        line-height: 78px;
        letter-spacing: -0.01em;
    }

    ${(props) =>
        props.center &&
        css`
            text-align: center;
        `}
`

const H2 = styled.h2`
    font-family: ${Variables.font.title};
    font-weight: normal;
    font-size: 44px;
    line-height: 50px;
    margin: 0;
    color: ${Variables.color.cocoa};

    h2,
    p {
        font-family: ${Variables.font.title};
        font-weight: normal;
        font-size: 44px;
        line-height: 50px;
        margin: 0;
        color: ${Variables.color.cocoa};

        ${media('<desktop')} {
            font-size: 28px;
            line-height: 32px;
            letter-spacing: 0.0025em;
        }
    }

    ${media('<desktop')} {
        font-size: 24px;
        line-height: 32px;
        letter-spacing: 0.0025em;
    }

    ${(props) =>
        props.center &&
        css`
            text-align: center;
        `}
`

const H3 = styled.h3`
    font-family: ${Variables.font.title};
    font-weight: 300;
    font-size: 48px;
    line-height: 125%;
    margin: 0;
    color: ${Variables.color.cocoa};

    ${(props) =>
        props.center &&
        css`
            text-align: center;
        `}
`

const H4 = styled.h4`
    font-family: ${Variables.font.title};
    font-style: normal;
    font-weight: normal;
    font-size: 34px;
    line-height: 135%;
    letter-spacing: 0.0025em;
    margin: 0;
    ${(props) =>
        props.center &&
        css`
            text-align: center;
        `}
`

const H5 = styled.h5`
    font-family: ${Variables.font.title};
    font-style: normal;
    font-weight: normal;
    font-size: 24px;
    line-height: 150%;

    margin: 0 0 20px;

    ${(props) =>
        props.center &&
        css`
            text-align: center;
        `}
    ${media('<desktop')} {
        font-size: 14px;
    }
`

const Overline = styled.div`
    font-family: ${Variables.font.button};
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 186%;
    color: ${Variables.color.cocoa};
    text-transform: uppercase;

    text-align: center;
    letter-spacing: 0.0125em;

    margin-bottom: 26px;

    ${media('<desktop')} {
        width: 100%;
        min-width: 80px;
        text-align: center;
    }

    ${(props) =>
        props.center &&
        css`
            text-align: center;
        `}
`

const H6 = styled.h6`
    font-family: ${Variables.font.title};
    font-weight: 500;
    font-size: 24px;
    line-height: 160%;
    text-align: center;
    letter-spacing: 0.0015em;
    margin: 0;
`

const BodyCopy = styled.div`
    font-family: ${Variables.font.bodyBold};
    font-style: normal;
    /* font-weight: 300; */
    font-size: 18px;
    line-height: 160%;
    letter-spacing: 0.1em;
    color: ${Variables.color.cocoa};

    p {
        margin: 0;
    }

    ${(props) =>
        props.center &&
        css`
            text-align: center;
        `}
`

export { H1, H2, H3, H4, H5, H6, Overline, BodyCopy }
